import React from 'react'
import { withNamespaces } from "react-i18next"

class StepBarTime extends React.Component {

  render() {
    const { step, t } = this.props;

    const steps = [
      { label: t('Zona'),    icon: 'fa-map-marker-alt' },
      { label: t('Taquilla'), icon: 'fa-lock'           },
      { label: t('Datos'),   icon: 'fa-user'            },
      { label: t('Pago'),    icon: 'fa-credit-card'     },
      { label: t('Ticket'),  icon: 'fa-ticket-alt'      },
    ];

    return (
      <div className="time-stepbar-fixed">
        <div className="time-stepbar">
          {steps.map((s, i) => {
            const num     = i + 1;
            const isActive = step === num;
            const isDone   = step > num;
            return (
              <React.Fragment key={i}>
                {i > 0 && (
                  <div className={`time-step-divider${isDone ? ' done' : ''}`} />
                )}
                <div className={`time-step${isActive ? ' active' : ''}${isDone ? ' done' : ''}`}>
                  <div className="time-step-number">
                    {isDone
                      ? <i className="fas fa-check" />
                      : <i className={`fas ${s.icon}`} />
                    }
                  </div>
                  <span className="time-step-label">{s.label}</span>
                </div>
              </React.Fragment>
            );
          })}
        </div>
      </div>
    )
  }
}

export default withNamespaces()(StepBarTime)
